import styled from 'styled-components';

export const InningHeader = styled.div`
    font-size: 24px;
    font-weight: bold;
    font-family: var(--gameday-primary-font);
    margin: 30px 0px;
    padding: 2px 0px;
    color: var(--gameday-primary-font-color);
`;

export const PlayFeedWrapper = styled.div`
  font-family: var(--gameday-primary-font);

  height: ${({ height }) => height};
  width: ${({ width }) => width};
  position: relative;

  &&:before {
    display: block;
    height: calc(100% - 8px); // this is to make sure the line doesn't pass the last icon
    position: absolute;
    width: 1px;
    background-color: var(--gameday-divider-color);
    content: '';
    left: 25px;
    top: 0px;
    background-clip: content-box;
    ${({ isFirstPitch }) => isFirstPitch ? 'padding-top: 6px;' : ''}
  }
`;

export const PlayFeedList = styled.div`
  height: 100%;
  overflow: auto;
  padding-left: 55px;
  overflow-x: hidden;
`;
